import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class LegendItem extends React.Component {
  render() {
    let {label, value, icon} = {
      label: this.props.label,
      value: this.props.value,
      icon: this.props.icon
    };

    if (value.trim() === 'all') {
      label = 'Show All';
    }

    return <div
      className={classnames('legend-item', this.props.selected ? 'selected' : '')}
      onClick={this.props.onClick}>
      {icon && <span className='icon'><img src={icon} alt={label}/></span>}
      <span className="name">{label}</span>
    </div>
  }
}

LegendItem.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

LegendItem.defaultProps = {
  icon: null,
  label: null,
  value: null,
  selected: false,
  onClick: null,
};

export default LegendItem;